import { t } from "@lingui/macro";
import graphql from "babel-plugin-relay/macro";
import { useFragment } from "react-relay";

import { ScreenHeader } from "@whoosh/design-system/src/apps/PatronApp/layout/ScreenHeader";
import { Button } from "@whoosh/design-system/src/components/controls/Button/Button";
import { ArrowLeftIcon } from "@whoosh/design-system/src/components/icons_v2/general";

import { TeeSheetAgendaHeaderDesktopNewFragment_club$key } from "./__generated__/TeeSheetAgendaHeaderDesktopNewFragment_club.graphql";

type TeeSheetAgendaHeaderDesktopNewProps = {
  onBackPress?: () => void;
  isScrolled: boolean;
  title: string;
  clubRef: TeeSheetAgendaHeaderDesktopNewFragment_club$key;
};

export const TeeSheetAgendaHeaderDesktopNew = ({
  onBackPress,
  isScrolled,
  title,
  clubRef,
}: TeeSheetAgendaHeaderDesktopNewProps) => {
  const club = useFragment(
    TeeSheetAgendaHeaderDesktopNewFragmentString,
    clubRef
  );

  return (
    <ScreenHeader
      subHeading={club?.name}
      variant={"REGULAR"}
      isRounded
      scrolled={isScrolled}
      leftItem={
        onBackPress ? (
          <Button
            variant="secondary"
            leftIcon={<ArrowLeftIcon />}
            onPress={onBackPress}
            testID="mobile-header-back-button-new"
            accessibilityLabel={t`Back button`}
          />
        ) : null
      }
      title={title}
      testID="agenda-header-screen-header-new"
    />
  );
};

export const TeeSheetAgendaHeaderDesktopNewFragmentString = graphql`
  fragment TeeSheetAgendaHeaderDesktopNewFragment_club on Club {
    name
    ...FacilityLogoFragment_club
  }
`;
